import { colors } from "@components/Theme/colors";
import { Box, Container, Divider, Grid, Link, Stack, Typography } from "@mui/material";
import { APITypes } from "utils/api.types";
import ContactForm from "./ContactForm";
interface VacatureDetailContactBlockProps {
  vacatureForm: APITypes.Components.VacatureDetailForm;
  position: APITypes.Components.Job;
  isScriptLoaded: boolean;
}
const VacatureDetailContactBlock = ({
  vacatureForm,
  position,
  isScriptLoaded
}: VacatureDetailContactBlockProps) => {
  return <>
      <Box sx={{
      mt: 10,
      display: "flex",
      justifyContent: "flex-end",
      backgroundColor: colors.greyColor.light
    }} data-sentry-element="Box" data-sentry-source-file="VacatureDetailContactBlock.tsx">
        <Stack flexDirection={"row"} gap={2} sx={{
        padding: "18px",
        marginTop: -11,
        backgroundColor: colors.green.main,
        justifyContent: "center",
        alignItems: "center",
        alignContent: "center"
      }} data-sentry-element="Stack" data-sentry-source-file="VacatureDetailContactBlock.tsx">
          <Stack justifyContent={"center"} alignItems={"center"} data-sentry-element="Stack" data-sentry-source-file="VacatureDetailContactBlock.tsx">
            <Typography sx={{
            fontWeight: 700,
            color: colors.primary.main
          }} data-sentry-element="Typography" data-sentry-source-file="VacatureDetailContactBlock.tsx">
              {position.recruiterName}
            </Typography>
            <Link underline="none" target="_blank" sx={{
            fontWeight: 500,
            color: colors.primary.main,
            cursor: "pointer",
            "&:hover": {
              color: "#3EA4DC"
            }
          }} href={`mailto:${position.recruiterEmail}`} data-sentry-element="Link" data-sentry-source-file="VacatureDetailContactBlock.tsx">
              {position.recruiterEmail}
            </Link>
            <Stack flexDirection={"row"} gap={1} data-sentry-element="Stack" data-sentry-source-file="VacatureDetailContactBlock.tsx">
              <Link underline="none" target="_blank" sx={{
              fontWeight: 500,
              color: colors.primary.main,
              cursor: "pointer",
              "&:hover": {
                color: "#3EA4DC"
              }
            }} href={`tel:${position.recruiterMobilePhone}`} data-sentry-element="Link" data-sentry-source-file="VacatureDetailContactBlock.tsx">
                {position.recruiterMobilePhone}
              </Link>
              {position.recruiterPhone && <>
                  <Divider orientation="vertical" variant="middle" flexItem sx={{
                backgroundColor: colors.primary.main
              }} />
                  <Link underline="none" target="_blank" sx={{
                fontWeight: 500,
                color: colors.primary.main,
                cursor: "pointer",
                "&:hover": {
                  color: "#3EA4DC"
                }
              }} href={`tel:${position.recruiterPhone}`}>
                    {position.recruiterPhone}
                  </Link>
                </>}
            </Stack>
          </Stack>
          <Divider orientation="vertical" variant="middle" flexItem sx={{
          mt: "8%",
          maxHeight: "40px",
          backgroundColor: colors.primary.main
        }} data-sentry-element="Divider" data-sentry-source-file="VacatureDetailContactBlock.tsx" />

          {position.recruiterLinkedIn && <Link underline="none" target="_blank" sx={{
          fontWeight: 500,
          color: colors.primary.main,
          cursor: "pointer",
          "&:hover": {
            color: "#3EA4DC"
          }
        }} href={position.recruiterLinkedIn}>
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.9162 0.205872H1.66765C0.745588 0.205872 0 0.933813 0 1.83381V21.1618C0 22.0618 0.745588 22.7941 1.66765 22.7941H20.9162C21.8382 22.7941 22.5882 22.0618 22.5882 21.1662V1.83381C22.5882 0.933813 21.8382 0.205872 20.9162 0.205872ZM6.70147 19.4544H3.34853V8.67205H6.70147V19.4544ZM5.025 7.20293C3.94853 7.20293 3.07941 6.33381 3.07941 5.26175C3.07941 4.18969 3.94853 3.32058 5.025 3.32058C6.09706 3.32058 6.96618 4.18969 6.96618 5.26175C6.96618 6.3294 6.09706 7.20293 5.025 7.20293ZM19.2485 19.4544H15.9V14.2132C15.9 12.9647 15.8779 11.3544 14.1574 11.3544C12.4147 11.3544 12.15 12.7176 12.15 14.125V19.4544H8.80588V8.67205H12.0176V10.1456H12.0618C12.5074 9.29852 13.6015 8.40293 15.2294 8.40293C18.6221 8.40293 19.2485 10.6353 19.2485 13.5382V19.4544Z" fill={colors.primary.main} />
              </svg>
            </Link>}
        </Stack>
      </Box>
      {vacatureForm && <Box id="form" py={10} sx={{
      backgroundColor: colors.greyColor.light
    }}>
          <Container>
            <Grid item xs={12}>
              <ContactForm form={vacatureForm} isScriptLoaded={isScriptLoaded} jobsId={position.jobsId} />
            </Grid>
          </Container>
        </Box>}
    </>;
};
export default VacatureDetailContactBlock;